import React from 'react';
import { useTranslation } from 'react-i18next';
import { useCurrency } from '../../../shared/CurrencyContext';

const ContractVehicles = ({ contractId, vehicles, readOnly = true }) => {
  const { t } = useTranslation();
  const { formatCurrency } = useCurrency();

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h5>{t('contracts.tabs.vehicles')}</h5>
        {readOnly && (
          <span className="badge bg-info-lt">{t('contracts.contractReadOnly')}</span>
        )}
      </div>

      {vehicles.length === 0 ? (
        <div className="text-center py-4">
          <p className="text-muted">{t('contracts.noVehicles')}</p>
        </div>
      ) : (
        <div className="table-responsive">
          <table className="table table-striped">
            <thead>
              <tr>
                <th>{t('contracts.fields.vehicle')}</th>
                <th>{t('contracts.fields.kilometers')}</th>
                <th>{t('contracts.fields.rateType')}</th>
                <th>{t('contracts.fields.rate')}</th>
                <th>{t('contracts.fields.totalCost')}</th>
                <th>{t('contracts.fields.order')}</th>
              </tr>
            </thead>
            <tbody>
              {vehicles.map((vehicle) => (
                <tr key={vehicle.id}>
                  <td>{vehicle.vehicle_name}</td>
                  <td>{vehicle.km} km</td>
                  <td>
                    <span className={`badge ${vehicle.rate_type === 'km' ? 'bg-primary-lt' : 'bg-info-lt'}`}>
                      {vehicle.rate_type === 'km' ? t('contracts.perKilometer') : t('contracts.flatRate')}
                    </span>
                  </td>
                  <td>{formatCurrency(vehicle.rate)}</td>
                  <td>
                    <strong>
                      {vehicle.rate_type === 'km'
                        ? formatCurrency(vehicle.km * vehicle.rate)
                        : formatCurrency(vehicle.rate)
                      }
                    </strong>
                  </td>
                  <td>{vehicle.order}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default ContractVehicles;
